/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import { useNavigate } from "react-router-dom";
import React, { useContext } from "react";
import { FaceScan } from "@swan-admin/swan-web-component";
import { UserDetailsContext } from "../../context/userDetails";
import { JWTToken, MEASUREMENT_STATUS, SESSION_STORAGE_KEY } from "../../vars";
import Asset from "../../components/Asset/Asset";
import { getLocalStorageData, getSessionStorage, hasNullSessionValue } from "../../utils/util";

function FaceScanPage() {
	const navigate = useNavigate();
	const { gender, email, shopDomain, userInfo } = useContext(UserDetailsContext);
	const { device } = userInfo;
	const [loader, setLoader] = React.useState(false);
	const latestToken = getLocalStorageData(JWTToken) || "";
	return (
		<>
			{loader && (
				<div className="fixed top-0 left-0 w-full h-full bg-black z-50">
					<Asset />
				</div>
			)}
			<FaceScan
				key={`${email}-${gender}-${shopDomain}-${device.focalLength}`}
				token={latestToken}
				userDetails={{
					email,
					deviceFocalLength: device.focalLength,
					gender,
					shopDomain,
					callbackUrl: hasNullSessionValue(SESSION_STORAGE_KEY.CALLBACK_URL) ? getSessionStorage(SESSION_STORAGE_KEY.CALLBACK_URL) : null,
				}}
				onUploadStart={() => setLoader(true)}
				onScanError={(errorDetails) => {
					console.log(errorDetails);
					setLoader(false);
				}}
				onScanSuccess={() => navigate(MEASUREMENT_STATUS)}
				onRetry={() => console.log("retry triggered.")}
			/>
		</>
	);
}

export default FaceScanPage;
